import "core-js/modules/web.dom.iterable";
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { queryEquipmentFaultAnalysis } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '30px'
    },
    position: {
      type: String,
      default: 'absolute'
    },
    left: {
      type: String,
      default: '0px'
    },
    marginLeft: {
      type: String,
      default: '0px'
    },
    type: {},
    id: {},
    queryType: {}
  },
  watch: {
    id: {
      handler: function handler(val) {
        this.querySewageQuotaList(this.type, val, this.queryType);
      },
      immediate: true
    },
    queryType: function queryType(val) {
      this.querySewageQuotaList(this.type, this.id, val);
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  methods: {
    initBarChart: function initBarChart(data) {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'

          }
        },
        legend: {
          data: data.legendData,
          top: '10%',
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          top: '40%',
          left: '5%',
          right: '4%',
          bottom: '0',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: data.xData,
          nameTextStyle: {
            color: '#fff'
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{
          type: 'value',
          nameTextStyle: {
            color: '#fff'
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          }
        }],
        series: data.seriesData
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      }, false);
    },
    // 趋势数据
    querySewageQuotaList: function querySewageQuotaList(type, id, queryType) {
      var _this = this;

      queryEquipmentFaultAnalysis({
        type: type,
        id: id,
        queryType: queryType
      }).then(function (res) {
        if (res.success) {
          var data1 = [],
              data2 = [],
              data3 = [],
              data4 = [],
              data5 = [],
              data6 = [],
              data7 = [],
              data8 = [];
          var data = {
            xData: [],
            seriesData: [],
            legendData: ['一般故障', '严重故障', '仪器故障', '仪器异常', '数据异常', '停电', '采水故障', '维护不当']
          };
          res.result.forEach(function (v, i) {
            data.xData.push(v.dateStr);
            data1.push(v.commonlyNum);
            data2.push(v.seriousNum);
            data3.push(v.c1Num);
            data4.push(v.c2Num);
            data5.push(v.c3Num);
            data6.push(v.c4Num);
            data7.push(v.c5Num);
            data8.push(v.c6Num);
          });
          data.seriesData = [{
            name: '一般故障',
            type: 'bar',
            stack: '故障',
            data: data1
          }, {
            name: '严重故障',
            type: 'bar',
            stack: '故障',
            data: data2
          }, {
            name: '仪器故障',
            type: 'bar',
            stack: '故障',
            data: data3
          }, {
            name: '仪器异常',
            type: 'bar',
            stack: '故障',
            data: data4
          }, {
            name: '数据异常',
            type: 'bar',
            stack: '故障',
            data: data5
          }, {
            name: '停电',
            type: 'bar',
            stack: '故障',
            data: data6
          }, {
            name: '采水故障',
            type: 'bar',
            stack: '故障',
            data: data7
          }, {
            name: '维护不当',
            type: 'bar',
            stack: '故障',
            data: data8
          }];

          _this.initBarChart(data);
        }
      });
    }
  }
};